import { Search } from 'lucide-react';
import { Dropdown } from '@new/common/ui/Dropdown/Dropdown';

interface SearchBarOption<T extends string> {
  label: string;
  value: T;
}

interface SearchBarProps<T extends string> {
  options: SearchBarOption<T>[];
  value: T;
  onChange: (value: T) => void;
  searchQuery: string;
  onSearchQueryChange: (value: string) => void;
  placeholder?: string;
}

export const SearchBar = <T extends string>({
  options,
  value,
  onChange,
  searchQuery,
  onSearchQueryChange,
  placeholder = 'Search...',
}: SearchBarProps<T>) => {
  return (
    <div className="grid grid-cols-[178px_1fr] h-12 flex-1 gap-0">
      <div className="border-[1.5px] border-r-0 border-(--neutral-white-NW800) overflow-visible bg-gray-50 shrink-0 grid">
        <Dropdown<T> options={options} value={value} onChange={onChange} />
      </div>

      <div className="flex items-center flex-1 px-4 gap-2 rounded-r-lg border-[1.5px] border-(--neutral-white-NW800) bg-(--neutral-white-NW1000)">
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => onSearchQueryChange(e.target.value)}
          placeholder={placeholder}
          className="w-full h-full text-sm focus:outline-none bg-transparent border-0"
        />
        <Search size={18} className="text-(--neutral-black-NB600) shrink-0 cursor-pointer" />
      </div>
    </div>
  );
};
